import App from '../modules';
import LoginComponent from '../pages/login/LoginComponent';
import { notFoundView } from '../pages/notFound/notFoundView';
import SuperAdminComponent from '../pages/superAdmin/SuperAdminComponent';
import IntegrationComponent from '../pages/integrationComponent/IntegrationComponent';
import HomeComponent from '../pages/home/HomeComponent';
import TestDataManagementComponent from '../pages/testDataManagement/TestDataManagementComponent';
import TestDesignComponent from '../pages/testDesign/TestDesignComponent';
import DesignHomeComponent from '../pages/designHome/DesignHomeComponent';
import ViewGenAIComponent from '../pages/viewGenAI/ViewGenAIComponent';

const {
  LOGIN,
  NOT_FOUND,
  SUPER_ADMIN,
  VIEW_INTEGRATION,
  // PARSE_REQUIREMENT,
  TEST_DATA_MANAGEMENT,
  VIEW_REQUIREMENT,
  DESIGN_HOME,
  TEST_CONFIG,
  HOME
} = App.Constants.ROUTES;

export const routes = [
  {
    route: LOGIN,
    component: LoginComponent,
    isPrivate: true,
    isRoleCheck: false,
    pageName: LOGIN,
    exact: true
  },
  {
    route: SUPER_ADMIN,
    component: SuperAdminComponent,
    isPrivate: true,
    isRoleCheck: false,
    pageName: SUPER_ADMIN,
    exact: true
  },
  {
    route: TEST_DATA_MANAGEMENT,
    component: TestDataManagementComponent,
    isPrivate: true,
    isRoleCheck: false,
    pageName: TEST_DATA_MANAGEMENT,
    exact: true
  },
  {
    route: DESIGN_HOME,
    component: DesignHomeComponent,
    isPrivate: true,
    isRoleCheck: false,
    pageName: DESIGN_HOME,
    exact: true
  },
  {
    route: VIEW_REQUIREMENT,
    component: ViewGenAIComponent,
    isPrivate: true,
    isRoleCheck: false,
    pageName: VIEW_REQUIREMENT,
    exact: true
  },
  {
    route: TEST_CONFIG,
    component: TestDesignComponent,
    isPrivate: true,
    isRoleCheck: false,
    pageName: TEST_CONFIG,
    exact: true
  },
  {
    route: VIEW_INTEGRATION,
    component: IntegrationComponent,
    isPrivate: true,
    isRoleCheck: false,
    pageName: VIEW_INTEGRATION,
    exact: true
  },
  {
    route: HOME,
    component: HomeComponent,
    isPrivate: true,
    isRoleCheck: false,
    pageName: HOME,
    exact: true
  },
  {
    route: NOT_FOUND,
    component: notFoundView,
    isPrivate: true,
    isRoleCheck: false,
    pageName: NOT_FOUND,
    exact: true
  }
];
